module.exports = __webpack_public_path__ + "img/Silver I.ff1e182b.png";